const formatCurrency = (
  value: number,
  currencyCode: string = 'USD',
): string => {
  const locale = currencyCode === 'PLN' ? 'pl-PL' : 'en';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    maximumFractionDigits: 0,
    currencyDisplay: 'symbol',
  }).format(value);
};

export default formatCurrency;
